
export interface Table {
  id?: number;
  tableNumber: string;
  capacity?: number;
  location?: string;
  barId?: string;
}
